import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Per-filter "Reset" — sits to the right of a filter title, shown only when
// that filter has exclusions. Size/style/placement match the Figma's reset
// verbatim: a ghost Button + RotateCcw + "Reset". Used identically by the
// Security Types, GICS and Geographic headers
// (Figma UniverseSelection.tsx:2642 / 2789 / 3141).
export function FilterResetButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="h-6 px-2 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 shrink-0"
    >
      <RotateCcw className="w-3 h-3" />
      Reset
    </Button>
  );
}
